export enum ImportType {
  building,
  address,
}
